const ProductSkeleton = () => {
  return (
    <div className="flex min-w-[160px] sm:w-[270px] flex-col shadow animate-pulse relative">
      {/* Image Skeleton */}
      <div className="relative aspect-square rounded-md bg-gray-300 overflow-hidden"></div>

      {/* Action buttons skeleton */}
      <div className="flex bg-gray-200 w-full justify-between h-10 mt-2 rounded">
        <div className="flex-1 mx-1 bg-gray-300 rounded"></div>
        <div className="flex-1 mx-1 bg-gray-300 rounded"></div>
        <div className="flex-1 mx-1 bg-gray-300 rounded"></div>
        <div className="flex-1 mx-1 bg-gray-300 rounded"></div>
        <div className="flex-1 mx-1 bg-gray-300 rounded"></div>
      </div>

      {/* Label Skeleton */}
      <div className="w-12 h-4 bg-gray-400 rounded absolute top-2 left-2"></div>

      {/* Text Skeletons */}
      <div className="flex flex-col w-full gap-1 p-2 mt-2">
        <div className="h-3 bg-gray-300 rounded w-1/2"></div>
        <div className="h-3 bg-gray-300 rounded w-3/4"></div>
        <div className="h-3 bg-gray-300 rounded w-1/3"></div>
      </div>
    </div>
  );
};

export default ProductSkeleton